module.exports = __webpack_public_path__ + "img/icon／24bz.07d97d4c.svg";